<template>
  <div class="lesson-impulse-html" v-html="value" />
</template>
<script lang="ts" setup>
  interface Props {
    value?: string | null
  }

  defineProps<Props>()
</script>
<style scoped>
  .lesson-impulse-html :deep(p + p),
  .lesson-impulse-html :deep(ul),
  .lesson-impulse-html :deep(ol) {
    margin-top: 0.5rem;
  }

  .lesson-impulse-html :deep(ul) {
    list-style: disc;
    padding-left: 1.25rem;
  }

  .lesson-impulse-html :deep(ol) {
    list-style: decimal;
    padding-left: 1.25rem;
  }

  .lesson-impulse-html :deep(a) {
    text-decoration: underline;
  }

  .lesson-impulse-html :deep(strong) {
    font-weight: 600 !important;
  }
</style>
